import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_TAG = 'FETCH_TAG'
const FETCH_TAGS = 'FETCH_TAGS'

export const getTagApi = apiCall(
  FETCH_TAG,
  ({ siteId, id }: { siteId: string; id: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/tags/${id}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getTagsApi = apiCall(
  FETCH_TAGS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/tags`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
